export default "__VITE_ASSET__hvf$Zeif__"